<template>
  <section class="hotspot-genius">
    <h3 v-html="$currentCollection.genie" />
    <h4>{{ $currentCollection.history.hotspot.title }}</h4>

    <div class="picture-wrapper">
      <div
        :class="`collections-${$currentCollection.id}-common-photo-genie`"
        class="picture"
      />
      <HotspotOverlay
        v-if="currentPin"
        class="hotspot-overlay"
        :title="currentPin.label"
        :description="currentPin.text"
        @close="currentPin = null"
      />
      <Plus
        v-for="pin in pins"
        :key="pin.id"
        :style="{ top: pin.y, left: pin.x }"
        class="pin"
        :class="{selected: currentPin === pin}"
        @click="currentPin = pin"
      />
    </div>
  </section>
</template>
<script>
import Plus from '@/assets/images/common/icons/plus.svg?inline';
import HotspotOverlay from '@/components/layouts/history/HotspotOverlay.vue';

export default {
  name: 'GeniusHotspot',
  components: {
    Plus,
    HotspotOverlay,
  },
  data() {
    return {
      currentPin: null,
    };
  },

  computed: {
    pins() {
      return this.$currentCollection.history.hotspot.pins;
    },
  },
};
</script>
<style lang="stylus" scoped>
.hotspot-genius {
  padding: 80px 80px;
  background: var(--white-color);
  transition: background 200ms ease-in-out, color 200ms ease-in-out;
  color: var(--main-color);

  +mobile() {
    padding: 40px 15px;
  }

  h3 {
    color: var(--main-color);
    text-align: center;
    font-size: 22px;
    font-style: italic;
    font-weight: 700;
    line-height: 1.1;
    margin: 0 auto 5px;
  }

  h4 {
    font-size: 18px;
    font-weight: 300;
    line-height: 1.1;
  }

  .picture-wrapper {
    position: relative;
    border-radius: 10px;
    // overflow: hidden;
    border: 1px solid var(--main-color);
    padding: 5px;
    max-width: 970px;
    margin: 30px auto;

    .picture {
      width: 100%;
      border-radius: 5px;
      overflow: hidden;
      background-size: cover;
      height: auto;
    }

    .hotspot-overlay {
      position: absolute;
      bottom: 20px;
      right: 20px;
      width: 310px;
      height: fit-content;
      z-index: 10;

      +mobile() {
        width: 100%;
        height: 100%;
        bottom: 0;
        right: 0;
      }
    }

    .pin {
      position: absolute;
      width: 40px;
      height: 40px;
      background: var(--white-color);
      border-radius: 50%;
      border: 1px solid var(--main-color);
      cursor: pointer;
      padding: 8px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
      transition: all 0.2s ease;
      transform: translate(-50%, -50%);

      +mobile() {
        width: 36px;
        height: 36px;
        padding: 4px;
      }

      * {
        stroke: var(--main-color);
      }

      &.selected {
        pointer-events: none;
        background: var(--main-color);
        border: 1px solid var(--white-color);
        * {
          stroke: var(--white-color);
        }
      }

      &:hover {
        background: var(--main-color);
        border: 1px solid var(--white-color);
        * {
          stroke: var(--white-color);
        }
        transform: translate(-50%, -50%)scale(1.1);
      }
    }
  }

}
</style>
